import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  forwardRef,
  HostBinding,
  Input,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

/**
 * `SdvorRadioComponent` предоставляет пользователю возможность выбора одного варианта из
 * нескольких предложенных. Этот компонент идеально подходит для случаев, когда необходимо
 * выбрать только одно значение из группы опций, например, при выборе пола, уровня
 * образования или типа подписки.
 *
 * ```ts
 * import { SdvorRadioComponent } from '@sdvor/shared/ui/v2';
 * ```
 */
@Component({
  selector: 'sd-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  imports: [FormsModule, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SdvorRadioComponent),
      multi: true,
    },
  ],
})
export class SdvorRadioComponent implements ControlValueAccessor {
  /** */
  @Input() name: string;
  /** */
  @Input() value: any;
  /** В неактивном состоянии */
  @Input() @HostBinding('class.disabled') disabled = false;

  /** @ignore */
  @ViewChild('input', { static: true }) inputRef: ElementRef;

  /** @ignore */
  actualValue: string;

  /** @ignore */
  private onChange: (_: any) => void;
  /** @ignore */
  private onTouched: (_: any) => void;

  /** @ignore */
  writeValue(value: string): void {
    this.actualValue = value;
    this.inputRef.nativeElement.checked = this.value === this.actualValue;
  }

  /** @ignore */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /** @ignore */
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  /** @ignore */
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /** @ignore */
  inputOnChange(value: string): void {
    this.onChange(value);
    this.onTouched(value);
  }
}
